import { useNavigate } from 'react-router-dom'
import Card from '../Card'
import Button from '../Button'
import iconDownload from '../../assets/icons/download.svg'
import iconCog from '../../assets/icons/settings.svg'
import iconTrash from '../../assets/icons/trash.svg'
import iconTriangleDown from '../../assets/icons/triangle-down.svg'
import iconTriangleUp from '../../assets/icons/triangle-up.svg'
import imgUsuariosIA from '../../assets/graphs/usuarios_ia.png'

function AIAssistantResultCard({
  title = "Usuarios activos vs Usuarios no activos",
  change = { value: 1234, type: 'down', text: 'menos Usuarios respecto al año pasado' },
  insights = {
    main: "Aumento de usuarios no activos por encima de la media",
    metrics: [
      { label: "Media habitual:", value: "750/día" },
      { label: "Periodo más alto:", value: "Junio 24 - Julio 24" },
      { label: "Periodo más bajo:", value: "Junio 24 y Diciembre 24" },
      { label: "Día más alto:", value: "15-07-2024" }
    ]
  },
  period = "15-01-2024 al 15-01-2025",
  chartImage = imgUsuariosIA,
  navigateTo = '/usuarios',
  onSettingsClick,
  onDeleteClick
}) {
  const navigate = useNavigate()

  return (
    <Card className="anomalia-card anomalia-card-ai">
      <div className="anomalia-content">
        <div className="anomalia-header">
          <div className="anomalia-title-section">
            <h3 className="card-title">{title}</h3>
            <div className={`anomalia-change anomalia-change--${change.type}`}>
              {change.type === 'down' && <img src={iconTriangleDown} alt="" className="trend-icon" />}
              {change.type === 'up' && <img src={iconTriangleUp} alt="" className="trend-icon" />}
              <span className="trend-number">{change.value.toLocaleString()}</span>
              <span className="trend-text">{change.text}</span>
            </div>
          </div>
          <Button variant="primary" size="s" onClick={onDeleteClick}>
            <img src={iconTrash} alt="" />
            <span>Eliminar</span>
          </Button>
        </div>

        <div className="anomalia-description-details">
          <p className="anomalia-description">
            <span style={{ fontWeight: '600' }}>{insights.main}</span>
          </p>
          <div className="anomalia-details">
            {insights.metrics.map((metric, index) => (
              <div key={index} className="anomalia-detail-item">
                <span className="detail-label">{metric.label}</span>
                <span className="detail-value">{metric.value}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="anomalia-chart-section">
        <div className="anomalia-chart-header">
          <h4 className="card-section-title">Periodo {period}</h4>
          <div className="card-actions">
            <Button variant="primary" size="s">
              <img src={iconDownload} alt="" />
            </Button>
            <Button variant="primary" size="s" onClick={onSettingsClick}>
              <img src={iconCog} alt="" />
            </Button>
          </div>
        </div>
        <div className="anomalia-chart-container">
          <img src={chartImage} alt={title} style={{ width: '100%', height: 'auto' }} />
        </div>
        <div className="anomalia-chart-footer">
          <span className="anomalia-ai-badge">
            <div className="anomalia-ai-icon"></div>
            Análisis generado con IA
          </span>
          <Button variant="primary-text" size="s" onClick={() => navigate(navigateTo)}>
            Ir a Usuarios →
          </Button>
        </div>
      </div>
    </Card>
  )
}

export default AIAssistantResultCard
